/* tslint:disable */
/* eslint-disable */
/**
 * RX360-WebAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AuthResponse } from './AuthResponse';
import {
    AuthResponseFromJSON,
    AuthResponseFromJSONTyped,
    AuthResponseToJSON,
} from './AuthResponse';
import type { DataOut } from './DataOut';
import {
    DataOutFromJSON,
    DataOutFromJSONTyped,
    DataOutToJSON,
} from './DataOut';

/**
 * 
 * @export
 * @interface DoctorOutAuthResponse
 */
export interface DoctorOutAuthResponse {
    /**
     * 
     * @type {boolean}
     * @memberof DoctorOutAuthResponse
     */
    status: boolean;
    /**
     * 
     * @type {number}
     * @memberof DoctorOutAuthResponse
     */
    statusCode: number;
    /**
     * 
     * @type {string}
     * @memberof DoctorOutAuthResponse
     */
    errorMessage?: string;
    /**
     * 
     * @type {DataOut}
     * @memberof DoctorOutAuthResponse
     */
    data?: DataOut;
    /**
     * 
     * @type {AuthResponse}
     * @memberof DoctorOutAuthResponse
     */
    auth?: AuthResponse;
}

/**
 * Check if a given object implements the DoctorOutAuthResponse interface.
 */
export function instanceOfDoctorOutAuthResponse(value: object): boolean {
    if (!('status' in value)) return false;
    if (!('statusCode' in value)) return false;
    return true;
}

export function DoctorOutAuthResponseFromJSON(json: any): DoctorOutAuthResponse {
    return DoctorOutAuthResponseFromJSONTyped(json, false);
}

export function DoctorOutAuthResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DoctorOutAuthResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'],
        'statusCode': json['status_code'],
        'errorMessage': json['error_message'] == null ? undefined : json['error_message'],
        'data': json['data'] == null ? undefined : DataOutFromJSON(json['data']),
        'auth': json['auth'] == null ? undefined : AuthResponseFromJSON(json['auth']),
    };
}

export function DoctorOutAuthResponseToJSON(value?: DoctorOutAuthResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'status': value['status'],
        'status_code': value['statusCode'],
        'error_message': value['errorMessage'],
        'data': DataOutToJSON(value['data']),
        'auth': AuthResponseToJSON(value['auth']),
    };
}

